import { Button, Input, Modal, Popconfirm, Select, Spin, Tabs, Tooltip, message } from 'antd';
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import React, { useEffect, useMemo, useState } from 'react';
import { DataIndexItem } from '../../../types/interfaces';
import { ReactComponent as DeleteIcon } from "../../../assets/svgs/icons/delete-icon.svg";
import { ReactComponent as CloseIcon } from "../../../assets/svgs/icons/close-icon.svg";
import { addItemsInBatch } from '../../tables/dataIndexTable/DataIndexLambdaUtils';
import { DataIndexMenuTableContainer } from '../DataManager.style';
import { convertStatus, failedStatus } from '../../tables/dataIndexTable/DataIndexUtils';

interface BatchIndexItem {
    onCancel: (inBatchId? : any) => void;
    tableData: DataIndexItem[];
    selectedBatchItems: DataIndexItem[];
}
// {selectedBatchItems}: DataIndexItem[]
const CreateBatch = ({ onCancel, selectedBatchItems, tableData }: BatchIndexItem) => {
    const [batchData, setBatchData] = useState<DataIndexItem[]>([]);
    const [existBatches, setExistBatches] = useState<DataIndexItem[]>([]);
    const [defaultValue, setDefaultValue] = useState<any>('');
    const [inputValue, setInputValue] = useState<string>('');
    const [batchName, setBatchName] = useState<string>('');
    const [batchId, setBatchId] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const handleCancel = () => {
        onCancel();
    };

    useEffect(() => {
        // console.log(tableData, "tabledata in confirm batch");
        let data = tableData.filter((item) => item.batch == true)
        if (data && data.length > 0) {
            setExistBatches(data);
        }

        setBatchData(() => selectedBatchItems);
    }, [selectedBatchItems])


    const columnsData = [
        { title: "Sr No", key: "number", size: 35 },
        { title: "Name", key: "name", size: 250, },
        { title: "EPSG", key: "raw_epsg", size: 100 },
        { title: "Action", key: "operation", size: 100 },
    ];


    const columns = useMemo<MRT_ColumnDef<any>[]>(() => {
        if (batchData.length === 0) {
            return [];
        }
        return columnsData.map(({ title, key, size }) => {
            if (key === "name") {
                return {
                    accessorKey: key,
                    enableSorting: false,
                    header: title || "",
                    size: size,
                    Cell: ({ row }) => {
                        const record: DataIndexItem = row.original;
                        let disabled = record.entwine_build_path === "";
                        if (!disabled) {
                            let isConversion = convertStatus.includes(record.conversion_status);
                            let isFailed = failedStatus.includes(record.conversion_status);
                            disabled = isConversion || isFailed;
                        }
                        return (
                            <div className='name_btn'>
                                <button
                                    className={`button-name`}
                                    type="button"
                                    disabled={disabled}
                                >
                                    {record.name}
                                </button>
                            </div>
                        );
                    },
                };
            }
            else if (key === "number") {
                return {
                    accessorKey: key,
                    enableSorting: false,
                    header: title || "",
                    size: size,
                    Cell: ({ row }) => {
                        return (
                            <div className='name_btn'>
                                <span>{row.index + 1}</span>
                            </div>
                        );
                    },
                };
            }
            else if (key === "operation") {
                return {
                    accessorKey: key,
                    enableSorting: false,
                    header: title || "",
                    size: size,
                    Cell: ({ row }) => {
                        const record: DataIndexItem = row.original;
                        return (
                            <div className="actionIconBox">
                                <Tooltip title="Delete" placement="rightTop">
                                    <Popconfirm
                                        placement="topRight"
                                        title="Are you sure to delete this item?"
                                        onConfirm={() => deleteBatchItem(record)}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <DeleteIcon key="DeleteIcon" title="Delete" color='#ffffff' />
                                    </Popconfirm>
                                </Tooltip>
                            </div>
                        );
                    },
                };
            }
            else {
                let data = {
                    accessorKey: key,
                    header: title || "",
                    size: size,
                }
                return data
            };

        })
    }, [batchData]);

    const table = useMaterialReactTable({
        columns,
        data: batchData,
        enableSorting: false,
        positionToolbarAlertBanner: 'none',
        rowNumberDisplayMode: "static",
        initialState: {
            showGlobalFilter: true,
            pagination: { pageSize: 5, pageIndex: 0 } // Set default rows per page to 5
        },
    });

    if (!table) {
        return null;
    }

    const handleChange = (value: string, option: any) => {
        const name = option?.props.name; // Get the name from the option's children
        const id = option?.props.value;
        setDefaultValue(name);
        setInputValue('');
        setBatchName(name);
        setBatchId(id);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setInputValue(value);
        setBatchName(value);
        setDefaultValue('');
        setBatchId('');
    };

    const addBatchData = async () => {
        setLoading(true);
        if (batchData.length > 0) {
            let batchItemsIds = batchData.map((item) => item.data_id);
            await addItemsInBatch(batchId, batchItemsIds, batchData[0].owner_id, batchName)
                .then((res: any) => {
                    // const data = JSON.parse(res);
                    message.success("Items added to batch successfully");
                    onCancel(res.batch_id);
                })
                .catch((err) => {
                    setLoading(false);
                    message.error(err);
                }).finally(() => {
                    setLoading(false);
                });
        }
    }

    const deleteBatchItem = (record: DataIndexItem) => {
        batchData.length == 1 && onCancel();
        setBatchData((prev) => {
            return prev.filter((item) => item.data_id !== record.data_id);
        });
    }

    const tabItems = [
        {
            label: (
                <span>
                    Batch
                </span>
            ),
            key: '1',
            children: (
                <>
                    <div className='batch_info'>
                        <div className='add_batch_block'>
                            <p>Existing Batch</p>
                            <Select
                                value={defaultValue}
                                onChange={(value, option) => handleChange(value, option)}
                                className="custom-select-dropdown custom_batch_input"
                            >
                                <Select.Option value="" name="">Select Batch</Select.Option>
                                {existBatches.map((item) => (
                                    <Select.Option key={item.data_id} name={item.name} value={item.data_id}>{item.name}</Select.Option>
                                ))}

                            </Select>
                        </div>
                        <div className='add_batch_block'>
                            <p>Batch Name</p>
                            <Input value={defaultValue !== '' ? defaultValue : inputValue} disabled={defaultValue === '' ? false : true} className='batch_name custom_batch_input' placeholder="Batch Name" onChange={handleInputChange} />
                        </div>

                    </div>

                    <div className="inputData_table_searchable dataIndex_table batch_info">
                        <p>Data Items</p>
                        <div className='loading_box'>
                            {batchData && batchData.length > 0 && (
                                <div className={`materialReactTableCustom batchCustomTable`}>
                                    <MaterialReactTable table={table} />
                                </div>
                            )}
                        </div>
                    </div>
                </>

            ),
        },
    ];

    return (
        <Modal
            centered
            open={true}
            onCancel={handleCancel}
            className="batch_modal create_batch_modal"
            closeIcon={<CloseIcon key="CloseIcon" color='#ffffff' onClick={handleCancel} />}
            footer={[
                <Button key="cancel" onClick={handleCancel} className="cancel_batch_button">Cancel</Button>,
                <Button loading={loading} key="ok" type="primary" onClick={addBatchData} className="ok_batch_button">
                    {inputValue === '' ? 'Update' : 'Add'}
                </Button>
            ]} // Custom close icon
            style={{
                backgroundColor: "#36BDBE",
                width: "100%", // Adjust the width as per your need
                maxWidth: "100%", // Set maximum width if needed
            }}
        >
            <DataIndexMenuTableContainer>
                <div className='table-container'>
                    <div className="custom-tab-container">
                        <Tabs defaultActiveKey="1"
                            items={tabItems}
                            key="1"
                            className="custom-tabs">
                        </Tabs>
                    </div>
                </div>
            </DataIndexMenuTableContainer>
        </Modal>
    );
}

export default CreateBatch;
